import { useContext } from 'react';
import { FilmContextInstance } from '../types/context';
/**
 * Returns the current context value, as given by the nearest `FilmContext` for the `FilmContextInstance`.
 */
export const useFilmContext = () => useContext(FilmContextInstance);
